// Experience Reducer

const experienceReducerDefaultState = {
    experienceList:{}
};

export default (state = experienceReducerDefaultState, action) =>{
    //console.log('Experience reducer: ', state);
    switch(action.type){

        case 'LIST_EXPERIENCE':
            return{
                ...state,
                experienceList: action.experience
            };
        default:
            return state;    
    }
}


// WEBPACK FOOTER //
// ./src/reducers/experience.js